import { render } from "./OrderForm.vue?vue&type=template&id=ad17d3a8&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=ad17d3a8&scoped=true&lang=css"

import exportComponent from "D:\\Documents\\Development\\carnitas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad17d3a8"]])

export default __exports__